import OutsorcersTable from "./OutsourcersTable";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

const OutsourcersTab = (props: TabPanelProps) =>{
  const { children, value, index, ...other } = props;
  return(
    <OutsorcersTable />
  )
}

export default OutsourcersTab